// Helper specialised in getting orderToken from different sources

const orderTokenHelperFactory = ({
    get,
    set,
    cartService,
    getPageParams,
    getServerProperty,
}) => {
    const getOrderToken = () => get('tokens.order_token');

    const setOrderToken = (orderToken) => {
        set('tokens.order_token', orderToken);
    };

    const aEnsureOrderToken = () =>
        new Promise((resolve) => {
            const orderToken = getOrderToken();

            if (orderToken) {
                resolve();
                return;
            }
            const { protocolVersion = 1 } = getPageParams();

            if (protocolVersion < 2) {
                const orderTokenFromServerData =
                    getServerProperty('order_token');

                // We set the order token for future retrieval
                setOrderToken(orderTokenFromServerData);
                resolve();
                return;
            }

            cartService.once('triggerSetOrderToken', (orderToken) => {
                setOrderToken(orderToken);
                resolve();
            });
            cartService.notify({ args: {}, type: 'app:requestOrderToken' });
        });

    return {
        getOrderToken,
        setOrderToken,
        aEnsureOrderToken,
    };
};

export default orderTokenHelperFactory;
